import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  FpxApprovalShellService,
  FpxViewShellService,
  FpxRepairShellService,
  FpxEntryShellService,
} from '@fpx/common/base-components';
import {
  IBtn,
  IFpxShell,
  IShellButtonAction,
  TNavigation,
} from '@fpx/common/models';

@Injectable({ providedIn: 'root' })
export class FpxShellService implements IFpxShell {
  private _shellAction: TNavigation = 'VIEW';
  formGroup!: FormGroup;
  public btnList: IBtn[] = [];

  constructor(
    private DECISION: FpxApprovalShellService,
    private VIEW: FpxViewShellService,
    private REPAIR: FpxRepairShellService,
    private ADD: FpxEntryShellService,
    private MODIFY : FpxEntryShellService
  ) {}

  doPreInit(): void {
    console.log('parent shell call');
    this.service.doPreInit();
  }

  setShellAction(shellAction: TNavigation) {
    this._shellAction = shellAction;
  }

  get service(): IFpxShell {
    return this[this._shellAction];
  }

  onBtnClick(btnAction: keyof IShellButtonAction) {
    console.log(btnAction);
    this.service.onBtnClick(btnAction);
  }

  _setFormGroup(form: FormGroup) {
    this.formGroup = form;
    this.service._setFormGroup(form);
    this.loadDependencies();
  }

  loadDependencies() {
    this.btnList = this.service.btnList;
  }

  get formInvalid(): boolean {
    return this.formGroup?.invalid;
  }

  get formValid(): boolean {
    return this.formGroup?.valid;
  }
}
